import API from 'services/API';

export default function searchInn(inn) {
  return API.request({
    method: 'GET',
    url: `/inspector/isInnAvailable/${inn}`,
  });
}
